import {createSelector} from '@reduxjs/toolkit'
import { mraPrincipalBrokerSelector } from './mraPrincipalBrokerSelector'

const mraBrokerNextStepSelector = createSelector(
    [state => state.primaryAgencyApplication,
    mraPrincipalBrokerSelector], 
    (primaryApplication, {principalBrokerApplication}) => {
        const agencyApplication = primaryApplication?.application
        const companyRjscDetails = agencyApplication?.businessLicenceData?.companyRjscDetails ?? {}
        const userApplicationReviewComplete = agencyApplication?.businessLicenceData?.userApplicationReviewComplete ?? false
        const principalBrokerDutiesConfirmation = agencyApplication?.businessLicenceData?.principalBrokerDutiesConfirmation ?? false

        return {
            applicationId : agencyApplication?.id,
            businessLicenceData : agencyApplication?.businessLicenceData ?? {},
            companyRjscDetails,
            principalBrokerApplicationReview : principalBrokerApplication?.businessLicenceData?.userApplicationReviewComplete ?? false,
            agencyApplicationReview : userApplicationReviewComplete,
            principalBrokerDutiesConfirmation
        }
    }
)

export const mraBrokerNextStepSelect = state => ({
    mraBrokerNextStep : mraBrokerNextStepSelector(state)
})
